import React from 'react';
import { Navigate } from 'react-router-dom';

// Services are now integrated into the main home page Apple-style scroll
// Redirect users to the home page since services information is available there
const ServicesPage = () => {
    return <Navigate to="/" replace />;
};

export default ServicesPage;